module.exports = __webpack_public_path__ + "static/media/08.1bd2ea65.jpg";